import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useToasterFacade } from '../../../ui/facades/toaster.facade';
import { useAuthFacade } from '../../facades/Auth.facade';
import SignUp from '../../presentations/SignUp';

const SignUpContainer = () => {

  const history = useHistory();
  const toasterFacade = useToasterFacade();
  const { t } = useTranslation();
  // const [formData, setFormData] = useState(null);
  const authFacade = useAuthFacade();

  const handleOnSubmit = (data: any) => {

    console.log('on submit ---');
    console.log(data);
    authFacade.createOrganization(data).then((response: any) => {

      console.log('response --------');
      console.log(response);
      
      toasterFacade.showSuccess(
        t("signUp.msg.success.accountCreatedSuccessfully")
      );
      history.push("set-password");
    })



  }

  return <div>
    <SignUp onSubmit={handleOnSubmit}></SignUp>
  </div>;
};

export default SignUpContainer;
